import React, { useState, useMemo, useContext } from "react";
import BodyHeader from "../BodyHeader";
import ViewIcon from "assets/icons/View.svg";
import PlusIcon from "assets/icons/Plus.svg";
import JobImage from "assets/images/Jobs.png";
import ReusableCard from "../ReusableCard";
import SearchBar from "../SearchBarActivities";
import EmptyActivities from "../EmptyActivities";
import { useNavigate } from "react-router-dom";

const Jobs = ({
  title = "",
  jobs,
  search = false,
  onManageJobClick,
  onScheduleWarrantyClick,
  onViewWarrantyDetailsClick,
  currentPage,
  setCurrentPage,
  resultsPerPage,
  onResultsPerPageChange,
  totalCount,
}) => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");

  // Filter jobs based on search query
  const filteredJobs = useMemo(() => {
    if (!searchQuery.trim()) {
      return jobs;
    }

    const query = searchQuery.toLowerCase();
    return jobs.filter((job) => {
      // Search by job title (issueType)
      if (job.issueType && job.issueType.toLowerCase().includes(query)) {
        return true;
      }
      // Search by property address (streetAddress)
      if (
        job.propertyAddress?.streetAddress &&
        job.propertyAddress.streetAddress.toLowerCase().includes(query)
      ) {
        return true;
      }

      return false;
    });
  }, [jobs, searchQuery]);

  const handleSearch = (value) => {
    setSearchQuery(value);
  };

  return (
    <div className="flex flex-col">
      <div className="flex flex-col justify-between  ">
        <h1 className=" font-medium text-[#242424] md:py-8 py-4">{title}</h1>
        {search && (
          <SearchBar
            label="Search"
            placeholder="Search by Job Title or Property"
            select={[
              { label: "Sort By", values: ["A", "B", "C"] },
              { label: "Date Range", values: ["A", "B", "C"] },
            ]}
            onSearch={handleSearch}
          ></SearchBar>
        )}
      </div>
      {jobs.length ? (
        <div className="flex flex-col gap-3 mt-4 mb-8">
          {/* {" "} */}
          <ReusableCard
            title={title}
            resultsPerPage={resultsPerPage}
            jobs={filteredJobs}
            classGrid="grid grid-cols-1 md:grid-cols-1 gap-3"
            onManageJobClick={onManageJobClick}
            onScheduleWarrantyClick={onScheduleWarrantyClick}
            onViewWarrantyDetailsClick={onViewWarrantyDetailsClick}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalCount={totalCount}
            onResultsPerPageChange={onResultsPerPageChange}
          ></ReusableCard>
        </div>
      ) : (
        <EmptyActivities
          label="No active jobs at the moment."
          description="All your jobs that are in progress will appear here once a contractor is hired."
          img={JobImage}
          additionalButton={true}
        ></EmptyActivities>
      )}
    </div>
  );
};

export default Jobs;
